"use strict";

// Copyright 2018-2020 The MathWorks, Inc.
define(['lit/lit-element/lit-element.bundled'], function (litElementComponents) {
  'use strict'; // Since this is a wrapper function, if we need to modify it for bug fixes.
  // We should be able to just return a different function with the modifications
  // before or after the call. No one should be looking at the prototype chain here.
  // since we are not a newable object.

  return (result, container, options = {}) => {
    if (options.scopeName) {
      throw new Error('scopeName should not be set in render options, use WidgetBase for scoped rendering');
    }

    return litElementComponents.render(result, container, options);
  };
});
//# sourceMappingURL=render.js.map
